module.exports = __webpack_public_path__ + "img/welcome.6c7a54fb.gif";